"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSessionConstants = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _misc = require("./misc");

var _getEnvironmentContext = require("../utils/getEnvironmentContext");

var _constants = require("../constants");

var _adobe = require("./adobe");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getSessionConstants = function getSessionConstants(base) {
  var userAgent = (0, _misc.getUserAgent)(); // Get browser data to include with requests:

  var _getEnvironmentContex = (0, _getEnvironmentContext.get)(userAgent),
      browserName = _getEnvironmentContex.browserName,
      browserVersion = _getEnvironmentContex.browserVersion,
      osName = _getEnvironmentContex.osName,
      osVersion = _getEnvironmentContex.osVersion,
      platform = _getEnvironmentContex.platform;

  return _objectSpread(_objectSpread({}, base), {}, {
    analytics_module_version: "9.6.44",
    adobe_mcid: (0, _adobe.getAdobeCookie)(),
    base_event_type: _constants.BASE_EVENT_TYPE,
    base_event_version: _constants.BASE_EVENT_VERSION,
    url: window.location.href,
    user_agent: userAgent,
    browser_name: browserName,
    browser_version: browserVersion,
    os: osName,
    os_ver: osVersion,
    platform: platform
  });
};

exports.getSessionConstants = getSessionConstants;